import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../../foundations/icons/Icon.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { CheckboxBase } from "../unstyled/CheckboxBase/CheckboxBase.js";
const checkbox = "_checkbox_t43cj_4";
const checkboxCheckmarkBox = "_checkboxCheckmarkBox_t43cj_12";
const checkboxCheckmark = "_checkboxCheckmark_t43cj_12";
const styles = {
  checkbox,
  checkboxCheckmarkBox,
  checkboxCheckmark,
  "is-selected": "_is-selected_t43cj_36",
  "is-active": "_is-active_t43cj_48",
  "is-read-only": "_is-read-only_t43cj_67",
  "is-invalid": "_is-invalid_t43cj_78"
};
const Checkbox = forwardRef(
  ({ children, className, isIndeterminate, isInvalid, isReadOnly, value, ...props }, ref) => {
    if (!children && !props["aria-label"] && !props["aria-labelledby"]) {
      console.error(
        "Checkbox: When no children are provided, either aria-label or aria-labelledby is required for accessibility."
      );
    }
    if (props["aria-label"] && props["aria-labelledby"]) {
      console.error(
        "Checkbox: Do not use both aria-label and aria-labelledby. Choose one for proper accessibility."
      );
    }
    const iconVariant = isIndeterminate ? "MinusSmall" : "Check1";
    return /* @__PURE__ */ jsxs(
      CheckboxBase,
      {
        ref,
        value,
        isIndeterminate,
        className: clsx(
          styles.checkbox,
          className,
          { [styles["is-invalid"]]: isInvalid },
          { [styles["is-read-only"]]: isReadOnly }
        ),
        selectedClassName: styles["is-selected"],
        pressedClassName: styles["is-active"],
        isReadOnly,
        isInvalid,
        ...props,
        children: [
          /* @__PURE__ */ jsx("div", { className: styles.checkboxCheckmarkBox, children: /* @__PURE__ */ jsx(Icon, { variant: iconVariant, "aria-hidden": true, className: styles.checkboxCheckmark }) }),
          children && typeof children === "string" ? /* @__PURE__ */ jsx(Text, { component: "span", children }) : /* @__PURE__ */ jsx(Fragment, { children })
        ]
      }
    );
  }
);
Checkbox.displayName = "Checkbox";
export {
  Checkbox
};
